// Browser SDK. Picked up automatically by the `sentry()` Astro integration,
// which looks for `sentry.client.config.(ts|js)` at the project root and injects
// it into every page (see astro.config.mjs).
//
// Errors only. This is a content site: there is no performance budget to spend
// on tracing spans, and Session Replay is deliberately never enabled — it
// records the reader's screen, which is far more than error tracking needs.
import * as Sentry from "@sentry/astro";
import {
  SENTRY_DATA_COLLECTION,
  SENTRY_DSN,
  resolveSentryEnvironment,
} from "./src/lib/sentry";

// No guard on `SENTRY_DSN`, deliberately. It cannot be empty: `src/lib/sentry.ts`
// resolves it as `import.meta.env.PUBLIC_SENTRY_DSN || BLOG_SENTRY_DSN`, and the
// second is a committed literal. This file previously wrapped the init in
// `if (SENTRY_DSN)` with a comment about local builds having no DSN — dead code
// and a false statement once that fallback arrived (WEB-11824 review).
//
// So a local `astro build` does initialise the SDK, and reports under the
// `development` environment that `resolveSentryEnvironment` defaults to. That is
// the same behaviour as every other Martide Astro site.
Sentry.init({
  dsn: SENTRY_DSN,
  environment: resolveSentryEnvironment(
    import.meta.env.PUBLIC_SENTRY_ENVIRONMENT,
  ),

  // Errors only — no tracing, no spans.
  tracesSampleRate: 0,

  // Session Replay stays off. Both rates are pinned at 0 so enabling it can
  // only ever be a deliberate edit, never an upgrade default.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  // Keep reader identity, cookies and IP addresses out of events.
  dataCollection: SENTRY_DATA_COLLECTION,

  initialScope: { tags: { app: "blog" } },
});
